import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { TypographyLabelMedium } from "components-redesign/Typography/Typography";
import { FlexContent } from "components/FlexContent/FlexContent";
import { useFeatureCheck } from "configuration";
import { INavigationMenuItem } from "model/routing";
import { Link, useLocation } from "react-router";
import { useRouteMenuStyles } from "./styles";

function RoutesMenu(props) {
  const { menuItems, rootPath } = props;
  const { pathname } = useLocation();
  const currentRouteItem = pathname.split("/")[1] || rootPath.replace("/", "");

  let selectedItemName = menuItems.find(
    (item) => item.route === currentRouteItem
  )?.name;
  if (!selectedItemName) {
    selectedItemName = menuItems.find((item) =>
      item.route.includes(currentRouteItem)
    )?.name;
  }

  return (
    <div
      style={{
        padding: 0,
        margin: 0,
      }}>
      {menuItems.map((item) => (
        <RoutesListItem
          item={item}
          selected={item.name === selectedItemName}
        />
      ))}
    </div>
  );
}

const RoutesListItem = ({
  item,
  selected,
}: {
  item: INavigationMenuItem;
  selected: boolean;
}) => {
  const { classes } = useRouteMenuStyles({ selected });
  const showItemByFF = useFeatureCheck(item.noAlphaFeatureFlag || "");
  if (item.noAlphaFeatureFlag && !showItemByFF) {
    return null;
  }

  const route = item.route;

  return (
    <div
      data-qa={`menu_item_${item.name}`}
      key={item.name}
      className={classes.li}>
      <Link to={route}>
        <div className={classes.menuItem}>
          <FlexContent
            direction="column"
            align="center"
            gap="4px">
            <ListItemIcon className={classes.icon}>
              <FlexContent
                justify="center"
                align="center">
                {item.icon}
              </FlexContent>
            </ListItemIcon>
            <ListItemText>
              <TypographyLabelMedium>{item.label}</TypographyLabelMedium>
            </ListItemText>
          </FlexContent>
        </div>
      </Link>
    </div>
  );
};

export default RoutesMenu;
